import type { PlanningEntity } from './PlanningEntity';
import { PlanningEntitySide } from './PlanningEntity';

export interface KindResolver {
  kind: string;
  regexp: RegExp;
  sideGroupIndex?: number;
  nameIndex?: number;
}

export class PlanningEntityFactory {
  private _kindResolversChain: Array<KindResolver>;

  public constructor(kindResolversChain: Array<KindResolver>) {
    this._kindResolversChain = kindResolversChain;
  }

  private _resolveSide(encodedSide: string): PlanningEntitySide | undefined {
    const lc = encodedSide.toLowerCase();
    if (lc.length == 1) {
      if (lc == 'l') return PlanningEntitySide.Left;
      if (lc == 'r') return PlanningEntitySide.Right;
    } else {
      if (lc == 'left') return PlanningEntitySide.Left;
      if (lc == 'right') return PlanningEntitySide.Right;
    }
  }

  private _makeDescriptor(rawName: string): string {
    return rawName.toLowerCase().replace(/\s+/, '_');
  }

  public createEntity(rawName: string): PlanningEntity | undefined {
    const match = this._kindResolversChain.find((entry) => entry.regexp.test(rawName));
    if (match) {
      const res = match.regexp.exec(rawName);
      if (!res) {
        throw new Error('Logic error');
      }
      const name = match.nameIndex !== undefined ? res[match.nameIndex] : rawName;
      const descriptor: string = this._makeDescriptor(rawName);
      const kind = match.kind;
      const side = match.sideGroupIndex !== undefined ? this._resolveSide(res[match.sideGroupIndex]) : undefined;
      if (match.sideGroupIndex !== undefined && !side) {
        throw new Error('Side is missing while it is obligatory');
      }
      return {
        importName: rawName,
        name: name,
        descriptor: descriptor,
        kind: kind,
        side: side
      };
    }
  }
}
